<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.note' | translate"
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    <p>
      {{ 'page.training_qualifications.finalize.modal.notes.info' | translate }}
    </p>
    <nz-form-item>
      <nz-form-control>
        <textarea
          rows="4"
          nz-input
          [formControl]="notesFormControl"
          [placeholder]="'general.write_a_note' | translate"
        ></textarea>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
